import { render, staticRenderFns } from "./Csr.vue?vue&type=template&id=9b79b360&scoped=true"
import script from "./Csr.vue?vue&type=script&lang=js"
export * from "./Csr.vue?vue&type=script&lang=js"
import style0 from "./Csr.vue?vue&type=style&index=0&id=9b79b360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b79b360",
  null
  
)

export default component.exports